var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"app-footer",attrs:{"padless":""}},[_c('span',{staticClass:"app-footer__text"},[_vm._v("© "+_vm._s(_vm.year)+" "+_vm._s(_vm.footer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }